// We need to set the publicpath as early as possible otherwise it won't work.
// Import this module above any components that rely on it.

// FAB-691: Tell webpack about the dynamic publicPath
if (__BUILD_PROD__) {
	__webpack_public_path__ = window.__cdn_url__ + '/'; // eslint-disable-line
}
